export default __webpack_public_path__ + "images/AF.9140d80.png";